interface AuthorityDocument {
  withWill: string;
  noWill: string;
}

const AUTHORITY_DOCUMENTS: Record<string, AuthorityDocument> = {
  AL: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  AK: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  AZ: { withWill: "Letters of Appointment", noWill: "Letters of Appointment" },
  AR: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  CA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  CO: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  CT: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  DE: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  FL: { withWill: "Letters of Administration", noWill: "Letters of Administration" },
  GA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  HI: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  ID: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  IL: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  IN: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  IA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  KS: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  KY: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  LA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  ME: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  MD: { withWill: "Letters of Administration", noWill: "Letters of Administration" },
  MA: { withWill: "Letters of Authority", noWill: "Letters of Authority" },
  MI: { withWill: "Letters of Authority", noWill: "Letters of Authority" },
  MN: { withWill: "Letters Testamentary", noWill: "Letters of General Administration" },
  MS: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  MO: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  MT: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NE: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NV: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NH: { withWill: "Certificate of Appointment", noWill: "Certificate of Appointment" },
  NJ: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NM: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NY: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  NC: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  ND: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  OH: { withWill: "Letters of Authority", noWill: "Letters of Authority" },
  OK: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  OR: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  PA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  RI: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  SC: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  SD: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  TN: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  TX: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  UT: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  VT: { withWill: "Letters of Administration", noWill: "Letters of Administration" },
  VA: { withWill: "Certificate of Qualification", noWill: "Certificate of Qualification" },
  WA: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  DC: { withWill: "Letters of Administration", noWill: "Letters of Administration" },
  WV: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
  WI: { withWill: "Domiciliary Letters", noWill: "Domiciliary Letters" },
  WY: { withWill: "Letters Testamentary", noWill: "Letters of Administration" },
};

const DEFAULT_DOCUMENT: AuthorityDocument = {
  withWill: "Letters Testamentary",
  noWill: "Letters of Administration",
};

export function getAuthorityDocumentName(
  stateAbbreviation: string | null | undefined,
  hasWill: string | null | undefined,
): string {
  const doc =
    (stateAbbreviation ? AUTHORITY_DOCUMENTS[stateAbbreviation.toUpperCase()] : null) ??
    DEFAULT_DOCUMENT;
  return hasWill === "yes" ? doc.withWill : doc.noWill;
}

export function getAuthorityDocumentType(
  hasWill: string | null | undefined,
): "letters_testamentary" | "letters_administration" {
  return hasWill === "yes" ? "letters_testamentary" : "letters_administration";
}
